import { render, staticRenderFns } from "./AlignmentEditor.vue?vue&type=template&id=0ea5beab&scoped=true&"
import script from "./AlignmentEditor.vue?vue&type=script&lang=js&"
export * from "./AlignmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea5beab",
  null
  
)

export default component.exports